import { render } from "./TronLinkImport.vue?vue&type=template&id=21b4b508&scoped=true"
import script from "./TronLinkImport.vue?vue&type=script&lang=js"
export * from "./TronLinkImport.vue?vue&type=script&lang=js"

import "./TronLinkImport.vue?vue&type=style&index=0&id=21b4b508&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b4b508"]])

export default __exports__